document.filterGroupTitleInit = () => {
  findOpenedTabs();

  /* filter group */
  $('.filter-group-title').on('click', (e) => {
    const target = e.currentTarget;
    const groupContainer = target.closest('.filter-group');

    /* disable car group collapse at 480px + */
    if ($(groupContainer).hasClass('filter-group-car') && !windowSizeHelper.isPhone()) {
      return;
    }

    toggleGroup(target, target.classList.contains('active'), 200);
  });
};

/**
 * @param {HTMLElement} target
 * @param {boolean} state
 * @param {number} time
 * @returns {boolean}
 */
const toggleGroup = (target, state, time) => {
  if (!state) {
    $(target).addClass('active');
  } else {
    $(target).removeClass('active');
  }

  $($(target.closest('.filter-group')).find('.filter-group-content')).slideToggle(time);
  store(target.dataset.name, $(target).hasClass('active'));
  return false;
};

/**
 * @param {string} option
 * @param {*} val
 * @returns {{}}
 */
const store = (option, val) => {
  const local = window.localStorage;
  let storage = {};

  if (local.getItem('CatalogTabStateStore') === null) {
    storage[option] = val;
  } else {
    storage = JSON.parse(local.getItem('CatalogTabStateStore'));
    storage[option] = val;
  }

  local.setItem('CatalogTabStateStore', JSON.stringify(storage));

  return storage;
};

const findOpenedTabs = () => {
  const local = window.localStorage.getItem('CatalogTabStateStore');
  if (local !== null) {
    const states = JSON.parse(local);

    Object.entries(states).forEach(([key, value]) => {
      const element = document.querySelector(`[data-name="${key}`);
      if (element !== null && value) {
        toggleGroup(element, element.classList.contains('active'), 0);
      }
    });
  }

  return false;
};
